module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 13
// module chunks = 0